import { render, staticRenderFns } from "./ByTariffFromDexNetTokenModal.vue?vue&type=template&id=62193028&scoped=true"
import script from "./ByTariffFromDexNetTokenModal.vue?vue&type=script&lang=ts"
export * from "./ByTariffFromDexNetTokenModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62193028",
  null
  
)

export default component.exports